import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const AlertIcon = memo(({ className, color = colors.functionals.alert, fontSize = 16 }: SvgIconProps) => (
  <SvgIcon className={className} style={{ fontSize }} width="21" height="20" viewBox="0 0 21 20" fill="none">
    <defs>
      <mask id="alert-icon-mask">
        <rect width="100%" height="100%" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.58603 14.7437C9.77597 14.5608 10.0791 14.3867 10.4591 14.3867C10.8391 14.3867 11.1423 14.5608 11.3322 14.7437C11.5222 14.9266 11.7029 15.2185 11.7029 15.5844C11.7029 15.9504 11.5222 16.2423 11.3322 16.4252C11.1423 16.6081 10.8391 16.7822 10.4591 16.7822C10.0791 16.7822 9.77597 16.6081 9.58603 16.4252C9.39608 16.2423 9.21533 15.9504 9.21533 15.5844C9.21533 15.2185 9.39608 14.9266 9.58603 14.7437Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4591 6.06152C10.9658 6.06152 11.3766 6.45711 11.3766 6.94509V12.9141C11.3766 13.4021 10.9658 13.7977 10.4591 13.7977C9.95231 13.7977 9.5415 13.4021 9.5415 12.9141V6.94509C9.5415 6.45711 9.95231 6.06152 10.4591 6.06152Z"
          fill="black"
        />
      </mask>
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33368 1.52382C8.72523 0.769712 9.52215 0.25 10.4593 0.25C11.3965 0.25 12.1934 0.769712 12.585 1.52382L12.5858 1.52546L20.4156 16.6836C20.4267 16.705 20.4368 16.7268 20.446 16.749C20.6811 17.3149 20.7487 18.1407 20.2466 18.7853C19.8658 19.2742 19.2057 19.6886 18.4522 19.6886H2.54797C1.79454 19.6886 1.13442 19.2742 0.753647 18.7853C0.734726 18.7611 0.717118 18.7358 0.700894 18.7098C0.288244 18.0475 0.300257 17.3603 0.554202 16.749C0.562939 16.7279 0.572512 16.7072 0.582901 16.6869L8.33368 1.52382Z"
      fill={color}
      mask="url(#alert-icon-mask)"
    />
  </SvgIcon>
));
